import React, { Component } from 'react'
import { getPrimaryColor } from '../components/Helper/CommonThings';
import { RotateCircleLoading } from 'react-loadingg';
import { getCookie } from '../utils/CookieHelper';
import Service from '../config/networkutils';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import SubContractor from './SubContractor';
import Users from '../components/Users/Users';

const token = getCookie("ptd_ts_token");
const user = JSON.parse(getCookie("ptd_ts_user"));

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

class SubcontractorTabs extends Component {
    constructor(props) {
        super(props)
        this.state = {
            view: 0,
            userAccess: {},
            isLoading: true,
        }
    }

    componentDidMount() {
        this.fetchUserAccess();
    }

    handleChange = (event, newValue) => {
        this.setState({ view: newValue });
    };

    fetchUserAccess() {

        Service.get(`/api/access/?uid=` + user.id, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                this.setState({
                    userAccess: res.data.length ? res.data[0] : {},
                    isLoading: false,
                });

            })
            .catch(error => {
                this.props.enqueueSnackbar('Uh oh! Something went wrong. Please try reloading the page or try later.', {
                    variant: 'error',
                    persist: true
                });
            });
    }

    render() {
        return (
            <div>
                {
                    this.state.isLoading ?
                        <RotateCircleLoading color={getPrimaryColor()} /> :
                        <Box sx={{ width: '100%' }}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <Tabs value={this.state.view} onChange={this.handleChange} aria-label="basic tabs example">
                                    <Tab label="By Employees" {...a11yProps(0)} />
                                    <Tab label="By Externals" {...a11yProps(1)} />
                                </Tabs>
                            </Box>
                            <CustomTabPanel value={this.state.view} index={0}>
                                <Users access={this.state.userAccess} byEmployees={true} link={false} />
                            </CustomTabPanel>

                            <CustomTabPanel value={this.state.view} index={1}>
                                <SubContractor userAccess={this.state.userAccess} />
                            </CustomTabPanel>
                        </Box>
                }
            </div>
        );
    }
}

export default SubcontractorTabs;